// extracted by mini-css-extract-plugin
export default {"aboutMeContent":"AboutMe_aboutMeContent__L+b13"};